import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { CompanyInfoTitleType, CompanyInfoTitleTypeTextMap } from '@domain/constant/companyInfo';
import classnames from 'classnames/bind';
import styles from './infoListItem.module.scss';
const cx = classnames.bind(styles);

interface InfoItemProps {
  type: CompanyInfoTitleType;
  title: ReactElement | string;
}

const InfoListItem = ({ type, title }: InfoItemProps) => {
  const titleRef = useRef<HTMLDivElement | null>(null);
  const [isEllipsis, setIsEllipsis] = useState(false);
  const itemWidth = 147;

  useEffect(() => {
    if (!titleRef.current) return;
    const child = titleRef.current.children?.[0] as HTMLElement;
    const width = child?.offsetWidth;
    if (width > itemWidth) setIsEllipsis(true);
  }, []);

  return (
    <li className={cx('listItem', `${type}`)}>
      <div className={cx('itemText')}>{CompanyInfoTitleTypeTextMap[type]}</div>
      <div className={cx('itemTitleWrap')}>
        <div ref={titleRef} className={cx('itemTitle')}>
          {title}
        </div>

        {/* [D] 말줄임이 생길 경우 노출해주세요. */}
        {isEllipsis && (
          <div className={cx('tooltip')}>
            <div className={cx('tooltipBox')}>{title}</div>
          </div>
        )}
      </div>
    </li>
  );
};

export default InfoListItem;
